export default __webpack_public_path__ + "static/img-channel-thumbnail-fourth-d2ab44c51eab5644f89816dc6d691bc1.png";